export function hasValidationError(errorMessage: string | undefined): boolean {
    return errorMessage != null;
}
